var cov_23u2yj4uwp = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/Progress.tsx",
      hash = "d80b4870502caf25a5f19404260aa07209df7f16",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/Progress.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 13,
          column: 9
        }
      },
      "2": {
        start: {
          line: 16,
          column: 22
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "3": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 57
        }
      },
      "4": {
        start: {
          line: 17,
          column: 24
        },
        end: {
          line: 17,
          column: 57
        }
      },
      "5": {
        start: {
          line: 20,
          column: 21
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "6": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 16
        }
      },
      "7": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 41,
          column: 5
        }
      },
      "8": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 50
        }
      },
      "9": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 54
        }
      },
      "10": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 56
        }
      },
      "11": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 54
        }
      },
      "12": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 54
        }
      },
      "13": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 52
        }
      },
      "14": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      "15": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 35
        }
      },
      "16": {
        start: {
          line: 61,
          column: 24
        },
        end: {
          line: 61,
          column: 34
        }
      },
      "17": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 41
        }
      },
      "18": {
        start: {
          line: 63,
          column: 17
        },
        end: {
          line: 63,
          column: 41
        }
      },
      "19": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 21
        }
      },
      "20": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 14
        }
      },
      "21": {
        start: {
          line: 69,
          column: 26
        },
        end: {
          line: 69,
          column: 36
        }
      },
      "22": {
        start: {
          line: 70,
          column: 17
        },
        end: {
          line: 70,
          column: 22
        }
      },
      "23": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 74,
          column: 5
        }
      },
      "24": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 40
        }
      },
      "25": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 21
        }
      },
      "26": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 17
        }
      },
      "27": {
        start: {
          line: 80,
          column: 22
        },
        end: {
          line: 80,
          column: 46
        }
      },
      "28": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 38
        }
      },
      "29": {
        start: {
          line: 81,
          column: 19
        },
        end: {
          line: 81,
          column: 38
        }
      },
      "30": {
        start: {
          line: 85,
          column: 37
        },
        end: {
          line: 85,
          column: 47
        }
      },
      "31": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 93,
          column: 5
        }
      },
      "32": {
        start: {
          line: 97,
          column: 60
        },
        end: {
          line: 97,
          column: 70
        }
      },
      "33": {
        start: {
          line: 98,
          column: 22
        },
        end: {
          line: 98,
          column: 46
        }
      },
      "34": {
        start: {
          line: 99,
          column: 18
        },
        end: {
          line: 101,
          column: 5
        }
      },
      "35": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 131,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 14
          }
        },
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 13,
            column: 9
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 23
          }
        },
        loc: {
          start: {
            line: 16,
            column: 50
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        loc: {
          start: {
            line: 36,
            column: 53
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 36
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 26
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 50
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 44
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 56
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 40
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 60
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 3
          }
        },
        loc: {
          start: {
            line: 68,
            column: 42
          },
          end: {
            line: 77,
            column: 3
          }
        },
        line: 68
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 79,
            column: 3
          }
        },
        loc: {
          start: {
            line: 79,
            column: 36
          },
          end: {
            line: 82,
            column: 3
          }
        },
        line: 79
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        loc: {
          start: {
            line: 84,
            column: 36
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 84
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 96,
            column: 3
          }
        },
        loc: {
          start: {
            line: 96,
            column: 11
          },
          end: {
            line: 132,
            column: 3
          }
        },
        line: 96
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 57
          }
        }, {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 57
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 41
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 41
          }
        }],
        line: 63
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }, {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }],
        line: 71
      },
      "3": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 38
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 38
          }
        }],
        line: 81
      },
      "4": {
        loc: {
          start: {
            line: 86,
            column: 11
          },
          end: {
            line: 93,
            column: 5
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 87,
            column: 28
          }
        }, {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 92,
            column: 13
          }
        }],
        line: 86
      },
      "5": {
        loc: {
          start: {
            line: 91,
            column: 9
          },
          end: {
            line: 91,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 39
          },
          end: {
            line: 91,
            column: 46
          }
        }, {
          start: {
            line: 91,
            column: 49
          },
          end: {
            line: 91,
            column: 60
          }
        }],
        line: 91
      },
      "6": {
        loc: {
          start: {
            line: 100,
            column: 7
          },
          end: {
            line: 100,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 17
          },
          end: {
            line: 100,
            column: 23
          }
        }, {
          start: {
            line: 100,
            column: 26
          },
          end: {
            line: 100,
            column: 33
          }
        }],
        line: 100
      },
      "7": {
        loc: {
          start: {
            line: 100,
            column: 36
          },
          end: {
            line: 100,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 48
          },
          end: {
            line: 100,
            column: 79
          }
        }, {
          start: {
            line: 100,
            column: 82
          },
          end: {
            line: 100,
            column: 88
          }
        }],
        line: 100
      },
      "8": {
        loc: {
          start: {
            line: 113,
            column: 20
          },
          end: {
            line: 113,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 113,
            column: 38
          },
          end: {
            line: 113,
            column: 40
          }
        }, {
          start: {
            line: 113,
            column: 43
          },
          end: {
            line: 113,
            column: 44
          }
        }],
        line: 113
      },
      "9": {
        loc: {
          start: {
            line: 115,
            column: 43
          },
          end: {
            line: 115,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 43
          },
          end: {
            line: 115,
            column: 52
          }
        }, {
          start: {
            line: 115,
            column: 56
          },
          end: {
            line: 115,
            column: 67
          }
        }],
        line: 115
      },
      "10": {
        loc: {
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 127,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 122,
            column: 20
          }
        }, {
          start: {
            line: 122,
            column: 24
          },
          end: {
            line: 127,
            column: 11
          }
        }],
        line: 122
      },
      "11": {
        loc: {
          start: {
            line: 128,
            column: 17
          },
          end: {
            line: 128,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 128,
            column: 29
          },
          end: {
            line: 128,
            column: 53
          }
        }, {
          start: {
            line: 128,
            column: 56
          },
          end: {
            line: 128,
            column: 67
          }
        }],
        line: 128
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/Upload/Progress.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { isValidElement } from 'react';
import Spin from '../Spin';
import { PureComponent } from '../component';
import { uploadClass } from './styles';
import Button from '../Button';
import Upload from './Upload';
import { isRTL } from '../config';
cov_23u2yj4uwp.s[0]++;

var SPIN = function SPIN(color) {
  cov_23u2yj4uwp.f[0]++;
  cov_23u2yj4uwp.s[1]++;
  return (
    /*#__PURE__*/
    React.createElement("span", {
      className: uploadClass('bg-spin'),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 11,
        columnNumber: 3
      }
    },
    /*#__PURE__*/
    React.createElement(Spin, {
      size: 10,
      name: "ring",
      color: color,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12,
        columnNumber: 5
      }
    }))
  );
};

cov_23u2yj4uwp.s[2]++;

var handleKeyDown = function handleKeyDown(e) {
  cov_23u2yj4uwp.f[1]++;
  cov_23u2yj4uwp.s[3]++;

  if (e.keyCode === 13) {
    cov_23u2yj4uwp.b[0][0]++;
    cov_23u2yj4uwp.s[4]++;
    e.target.click();
  } else {
    cov_23u2yj4uwp.b[0][1]++;
  }
};

var DefaultProps = (cov_23u2yj4uwp.s[5]++, {
  type: 'primary',
  size: 'default',
  outline: false
});

var Progress =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Progress, _PureComponent);

  var _super = _createSuper2(Progress);

  function Progress(props) {
    var _this2;

    _classCallCheck(this, Progress);

    cov_23u2yj4uwp.f[2]++;
    cov_23u2yj4uwp.s[6]++;
    _this2 = _super.call(this, props);
    _this2.handleStart = void 0;
    _this2.handleOver = void 0;
    cov_23u2yj4uwp.s[7]++;
    _this2.state = {
      progress: -1
    };
    cov_23u2yj4uwp.s[8]++;
    _this2.handleError = _this2.handleError.bind(_assertThisInitialized(_this2));
    cov_23u2yj4uwp.s[9]++;
    _this2.handleSuccess = _this2.handleSuccess.bind(_assertThisInitialized(_this2));
    cov_23u2yj4uwp.s[10]++;
    _this2.handleProgress = _this2.handleProgress.bind(_assertThisInitialized(_this2));
    cov_23u2yj4uwp.s[11]++;
    _this2.handleStart = _this2.handleChange.bind(_assertThisInitialized(_this2), 0);
    cov_23u2yj4uwp.s[12]++;
    _this2.handleOver = _this2.handleChange.bind(_assertThisInitialized(_this2), -1);
    cov_23u2yj4uwp.s[13]++;
    _this2.handleUpload = _this2.handleUpload.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(Progress, [{
    key: "handleChange",
    value: function handleChange(p) {
      cov_23u2yj4uwp.f[3]++;
      cov_23u2yj4uwp.s[14]++;
      this.setState({
        progress: p
      });
    }
  }, {
    key: "handleProgress",
    value: function handleProgress(file) {
      cov_23u2yj4uwp.f[4]++;
      cov_23u2yj4uwp.s[15]++;
      this.handleChange(file.process);
    }
  }, {
    key: "handleError",
    value: function handleError(xhr, file) {
      cov_23u2yj4uwp.f[5]++;

      var _ref = (cov_23u2yj4uwp.s[16]++, this.props),
          onError = _ref.onError;

      var msg;
      cov_23u2yj4uwp.s[17]++;

      if (onError) {
        cov_23u2yj4uwp.b[1][0]++;
        cov_23u2yj4uwp.s[18]++;
        msg = onError(xhr, file);
      } else {
        cov_23u2yj4uwp.b[1][1]++;
      }

      cov_23u2yj4uwp.s[19]++;
      this.handleOver();
      cov_23u2yj4uwp.s[20]++;
      return msg;
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(value) {
      cov_23u2yj4uwp.f[6]++;

      var _ref2 = (cov_23u2yj4uwp.s[21]++, this.props),
          onSuccess = _ref2.onSuccess;

      var result = (cov_23u2yj4uwp.s[22]++, value);
      cov_23u2yj4uwp.s[23]++;

      if (onSuccess) {
        cov_23u2yj4uwp.b[2][0]++;
        cov_23u2yj4uwp.s[24]++;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // @ts-ignore
        result = onSuccess.apply(void 0, [value].concat(args));
      } else {
        cov_23u2yj4uwp.b[2][1]++;
      }

      cov_23u2yj4uwp.s[25]++;
      this.handleOver();
      cov_23u2yj4uwp.s[26]++;
      return result;
    }
  }, {
    key: "handleUpload",
    value: function handleUpload(e) {
      cov_23u2yj4uwp.f[7]++;
      var uploading = (cov_23u2yj4uwp.s[27]++, this.state.progress >= 0);
      cov_23u2yj4uwp.s[28]++;

      if (uploading) {
        cov_23u2yj4uwp.b[3][0]++;
        cov_23u2yj4uwp.s[29]++;
        e.stopPropagation();
      } else {
        cov_23u2yj4uwp.b[3][1]++;
      }
    }
  }, {
    key: "renderLoadingView",
    value: function renderLoadingView(color) {
      cov_23u2yj4uwp.f[8]++;

      var _ref3 = (cov_23u2yj4uwp.s[30]++, this.props),
          placeholder = _ref3.placeholder,
          loading = _ref3.loading;

      cov_23u2yj4uwp.s[31]++;
      return (
        /*#__PURE__*/
        isValidElement(loading) ? (cov_23u2yj4uwp.b[4][0]++,
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 87,
            columnNumber: 7
          }
        }, loading)) : (cov_23u2yj4uwp.b[4][1]++,
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 89,
            columnNumber: 7
          }
        }, SPIN(color), typeof loading === 'string' ? (cov_23u2yj4uwp.b[5][0]++, loading) : (cov_23u2yj4uwp.b[5][1]++, placeholder)))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_23u2yj4uwp.f[9]++;

      var _ref4 = (cov_23u2yj4uwp.s[32]++, this.props),
          placeholder = _ref4.placeholder,
          type = _ref4.type,
          size = _ref4.size,
          outline = _ref4.outline,
          others = _objectWithoutProperties(_ref4, ["placeholder", "type", "size", "outline"]);

      var uploading = (cov_23u2yj4uwp.s[33]++, this.state.progress >= 0);
      var style = (cov_23u2yj4uwp.s[34]++, _defineProperty({}, isRTL() ? (cov_23u2yj4uwp.b[6][0]++, 'left') : (cov_23u2yj4uwp.b[6][1]++, 'right'), uploading ? (cov_23u2yj4uwp.b[7][0]++, "".concat(100 - this.state.progress, "%")) : (cov_23u2yj4uwp.b[7][1]++, '100%')));
      cov_23u2yj4uwp.s[35]++;
      return (
        /*#__PURE__*/
        React.createElement(Upload, Object.assign({}, others, {
          limit: undefined,
          onProgress: this.handleProgress,
          onStart: this.handleStart,
          showUploadList: false,
          onError: this.handleError,
          onSuccess: this.handleSuccess,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103,
            columnNumber: 7
          }
        }),
        /*#__PURE__*/
        React.createElement(Button, {
          tabIndex: others.disabled ? (cov_23u2yj4uwp.b[8][0]++, -1) : (cov_23u2yj4uwp.b[8][1]++, 0),
          disabled: others.disabled,
          className: uploadClass('button', (cov_23u2yj4uwp.b[9][0]++, uploading) && (cov_23u2yj4uwp.b[9][1]++, 'uploading')),
          type: type,
          size: size,
          outline: outline,
          onClick: this.handleUpload,
          onKeyDown: handleKeyDown,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 112,
            columnNumber: 9
          }
        }, (cov_23u2yj4uwp.b[10][0]++, uploading) && (cov_23u2yj4uwp.b[10][1]++, [
        /*#__PURE__*/
        React.createElement("div", {
          key: "cover",
          className: uploadClass('cover'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 123,
            columnNumber: 13
          }
        }),
        /*#__PURE__*/
        React.createElement("div", {
          key: "bg",
          style: style,
          className: uploadClass('bg'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 124,
            columnNumber: 13
          }
        }, this.renderLoadingView('#fff'))]),
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 128,
            columnNumber: 11
          }
        }, uploading ? (cov_23u2yj4uwp.b[11][0]++, this.renderLoadingView()) : (cov_23u2yj4uwp.b[11][1]++, placeholder))))
      );
    }
  }]);

  return Progress;
}(PureComponent);

Progress.defaultProps = DefaultProps;
export default Progress;